import React from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import ButtonSpinner from "components/Loading/ButtonSpinner";

const InputDialog = ({
  value,
  onChange,
  isOpen,
  isClose,
  label,
  placeholder,
  buttonText,
  validationError,
  onClick,
  loading,
}) => {
  return (
    <AnimatedDialogLayout isOpen={isOpen} onClose={isClose}>
      <div className="max-w-lg w-full sm:w-[500px]">
        <h1 className="text-black font-semibold text-[18px] text-center leading-[21.78px]">
          {label}
        </h1>
        <input
          value={value}
          onChange={onChange}
          type="text"
          placeholder={placeholder}
          className="outline-none bg-transparent mt-[11px] border border-[#D1D1D1] rounded-[11px] h-[61px] w-full text-[16px] font-medium placeholder:text-[#949494] px-[15px]"
        />

        <button
          onClick={onClick}
          disabled={validationError || loading}
          className={`${
            validationError ? "error-shake" : ""
          }  bg-primary mt-5 disabled:cursor-not-allowed text-white rounded-[11px] h-[51px] w-full grid justify-center items-center font-semibold text-[18px]`}
        >
          {loading ? (
            <ButtonSpinner />
          ) : validationError ? (
            validationError
          ) : (
            buttonText
          )}
        </button>
      </div>
    </AnimatedDialogLayout>
  );
};

export default InputDialog;
